export default __webpack_public_path__ + "static/media/chevron_double_left.a89a7406.svg";